// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { getDashboardData, getCampaignDetails, getNsuCashbackDetails } from "./_request";
import { useEffect, useMemo, useState } from "react";
import pointBrand from "../../assets/images/icons/catering-icons/ic-my-points.svg";
import MDButton from "components/MDButton";
import dollarBag from "../../assets/images/icons/catering-icons/whiteDollarBag.svg";

import UpdatePasswordModal from "../../examples/Modal/UpdatePassWordModal";
import { resendOtp, updateCustomerPassword, verifyTokenApi } from "../authentication/_request";
import SimpleBackdrop from "components/MDLoader_Backdrop";
import MDTypography from "components/MDTypography";

import { useAuth } from "context";
import EmailCustomModal from "examples/Modal/EmailConfirmationModal";
import { getGtmCode } from "core/AuthHelper";
import { getRedeemPoints } from "layouts/mypoint/_request";
import { generateGiftCard } from "layouts/mypoint/_request";
import { expireRedeemPoints } from "layouts/mypoint/_request";
import { useLocation, useNavigate } from "react-router-dom";
import { AnalyticsEvents, CONVERSION_POINTS } from "../../core/constant";
import formatNumberWithCommas from "../../core/utils/formatNumberWithCommas";
import PendingWelcomeBonusBanner from "components/PendingWelcomeBonusBanner";
import { NavbarAlert } from "examples/Alert";
import config from "../../config/config";
import { updateCustomerAPI } from "layouts/profile/_request";
import OtpConfirmationModal from "examples/Modal/OtpConfirmationModal";
import { usePhoneVerification } from "hooks/usePhoneVerification";
import TagManager from "react-gtm-module";
import { setGtmCode } from "../../core/AuthHelper";
import CampaignBannerCarousel from "./components/OrdersOverview/CampaignBannerCarousel";
import { StatCard } from "examples/Cards/StatisticsCards/StatCard";
import {
  StatCardWithButton,
  getRedeemDisabledReason,
} from "examples/Cards/StatisticsCards/StatCard";
import { useAnalyticsEvent } from "hooks/useAnalyticsEvent";
import UpdateNameModal from "examples/Modal/UpdateNameModal";

const notificationEmail =
  config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].NOTIFICATION_EMAIL;

function Dashboard() {
  const {
    verifiedCustomer,
    saveAuthData,
    showSnackbarWithMessage,
    miniSidenav,
    setVerifiedCustomer,
  } = useAuth();

  const {
    showOtpModal,
    verificationIdentifier,
    verificationType,
    handleOtpVerify,
    handleSendOTP,
    handleDismissOtpModal,
    holdPhoneVerification,
    resumePhoneVerification,
    checkPhoneVerification,
  } = usePhoneVerification();

  const [dashboardLoader, setDashboardLoader] = useState(true);
  const [recentOrderData, setRecentOrderData] = useState([]);
  const [topRestaurantData, setTopRestaurantData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [availablePoints, setAvailablePoints] = useState(0);
  const [totalPointsEarned, setTotalPointsEarned] = useState(0);
  const [totalRedeemedPoints, setTotalReedemedPonts] = useState(0);
  const [expirePoints, setExpirePoints] = useState({});
  const [mostRewardingRestaurant, setMostRewardingRestaurant] = useState();
  //DefaultPassword Logic
  const [spinner, setSpinner] = useState(false);
  const [userPassword, setUserPassword] = useState("");
  const [passwordModalComplete, setPasswordModalComplete] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);

  const [openUpdateNameModal, setOpenUpdateNameModal] = useState(false);
  const [nameModalLoader, setNameModalLoader] = useState(false);
  // const [needsNameUpdate, setNeedsNameUpdate] = useState(false);

  const [campaignEnrollments, setCampaignEnrollments] = useState([]);
  const [pendingWelcomeBonuses, setPendingWelcomeBonuses] = useState();
  const [openUpdatePasswordModal, setOpenUpdatePasswordModal] = useState(false);
  const location = useLocation();
  const forgotPassword = location.state?.forgotPassword || false;

  const { darkMode } = useAuth();

  const [loader, setLoader] = useState(false);
  const [minRedeemPoints, setMinRedeemPoints] = useState(0);
  const [openRedeemModal, setopenRedeemModal] = useState(false);
  const [redeemPoints, setRedeemPoints] = useState(0);
  const [redeemAmount, setRedeemAmount] = useState(0);
  const [isPendingRedeemptionRequestAmount, setIsPendingRedeemRequestAmount] = useState();
  const [userEmail, setUserEmail] = useState("");
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState("");
  const [status, setStatus] = useState({
    isOTPVisible: false,
  });
  const [otp, setOtp] = useState("");
  const [gtmInitialized, setGtmInitialized] = useState(false);
  const { trackCustomEvent } = useAnalyticsEvent();

  const checkIfNameNeedsUpdate = (customer) => {
    const email = customer?.email || "";
    const emailPrefix = email.split("@")[0].toLowerCase();
    const firstName = customer?.firstName?.toLowerCase().trim() || "";

    const emailPrefixWithoutNumbers = emailPrefix.replace(/\d+/g, "");

    return emailPrefixWithoutNumbers === firstName;
  };

  const updateCustomerName = async ({ firstName, lastName }) => {
    try {
      setNameModalLoader(true);
      const {
        data: { success, data, message },
      } = await updateCustomerAPI({
        firstName,
        lastName,
      });

      if (success) {
        await saveAuthData(data.tokens);
        const verifyResponse = await verifyTokenApi({ accessToken: data.tokens.accessToken });
        const { success: verifySuccess, data: verifyData } = verifyResponse.data;

        if (verifySuccess) {
          showSnackbarWithMessage({
            type: "success",
            message: message || "Name updated successfully!",
          });

          setOpenUpdateNameModal(false);

          // Resume phone verification after name update
          setTimeout(() => {
            resumePhoneVerification();
          }, 300);
        }
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      showSnackbarWithMessage({
        type: "error",
        message: e.message || "Failed to update name",
      });
    } finally {
      setNameModalLoader(false);
    }
  };

  const handleClose = () => {
    setOpenUpdatePasswordModal(false);
    setPasswordModalComplete(true);
    setTimeout(() => {
      resumePhoneVerification();
    }, 200);
  };

  const handleNameModalClose = () => {
    setOpenUpdateNameModal(false);
    // Resume phone verification after closing
    setTimeout(() => {
      resumePhoneVerification();
    }, 200);
  };

  const updatePassWord = async (newPassword) => {
    try {
      setModalLoader(true);
      setSpinner(true);
      const updatePasswordResponse = await updateCustomerPassword({
        newPassword,
        userPassword,
        forgotPassword: verifiedCustomer?.forgotPassword || !!forgotPassword,
      });
      const { success, data, message } = updatePasswordResponse.data;
      if (success) {
        const authData = data.tokens;
        await saveAuthData(authData);
        const verifyResponse = await verifyTokenApi({ accessToken: authData.accessToken });
        const { success: verifySuccess, data: verifyData } = verifyResponse.data;
        if (verifySuccess && !verifyData.verifiedData.defaultPassword) {
          showSnackbarWithMessage({
            type: "success",
            message: message,
          });
          setPasswordModalComplete(true);
          setOpenUpdatePasswordModal(false);

          const customer = verifiedCustomer;
          const needsUpdate = checkIfNameNeedsUpdate(customer);

          if (needsUpdate) {
            setTimeout(() => {
              setOpenUpdateNameModal(true);
            }, 300);
          } else {
            setTimeout(() => {
              resumePhoneVerification();
            }, 300);
          }
        }
      } else {
        showSnackbarWithMessage({
          type: "error",
          message: message,
        });
        setModalLoader(false);
        setSpinner(false);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setModalLoader(false);
      setSpinner(false);
    }
  };

  useEffect(() => {
    if ((!verifiedCustomer?.simulateUser && verifiedCustomer.defaultPassword) || forgotPassword) {
      // If password needs to be set, hold off on phone verification
      holdPhoneVerification();
      setOpenUpdatePasswordModal(true);
    } else {
      // If no password needs to be set, allow phone verification to proceed normally
      setPasswordModalComplete(true);
    }
  }, [verifiedCustomer, holdPhoneVerification]);

  //DefaultPassword Logic END

  const dashboardData = async () => {
    try {
      const {
        data: { success, data },
      } = await getDashboardData();
      if (success && data) {
        setRecentOrderData(data.recentOrders);
        setAvailablePoints(data.availableToRedeem);
        setTotalReedemedPonts(data.pointRedeemed);
        setTotalPointsEarned(data.pointEarned);
        setMostRewardingRestaurant(data.maxCashbackEarnedRestaurant);
        setTopRestaurantData(data.customerOrderSummary);
        setBrandData(data.brandMemberships || []);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const campaignData = async () => {
    try {
      const {
        data: { success, data },
      } = await getCampaignDetails(true);
      if (success && data?.enrollments?.length) {
        setCampaignEnrollments(
          data.enrollments.filter((e) => e.isCampaign),
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
  const fetchPendingWelcomeBonuses = async () => {
    try {
      const {
        data: { success, data },
      } = await getNsuCashbackDetails();
      if (success) {
        setPendingWelcomeBonuses(data.pendingWelcomeBonuses);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getExpirePoints = async () => {
    try {
      const { data } = await expireRedeemPoints();
      if (data.success) {
        setExpirePoints(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const loadDashboard = async () => {
      await Promise.allSettled([
        dashboardData(),
        campaignData(),
        fetchPendingWelcomeBonuses(),
        getExpirePoints(),
      ]);
      setDashboardLoader(false);
    };
    loadDashboard();
  }, []);

  useEffect(() => {
    if (
      (!verifiedCustomer?.simulateUser && verifiedCustomer.defaultPassword) ||
      verifiedCustomer?.forgotPassword
    ) {
      setOpenUpdatePasswordModal(true);
    }
  }, [verifiedCustomer]);

  const handleRedeemClose = () => {
    setopenRedeemModal(!openRedeemModal);
    setStatus({
      isOTPVisible: false,
    });
    setOtp("");
  };

  const getRedeemPointsData = async () => {
    try {
      const {
        data: { success, data },
      } = await getRedeemPoints();
      if (success) {
        setIsPendingRedeemRequestAmount(data?.redemption_request_points || 0);
        if (data.customerPoints) {
          setRedeemPoints(data.customerPoints);
          setRedeemAmount(data.customerPoints / 100);
          setMinRedeemPoints(data.minimum_points);
        } else {
          setRedeemPoints(0);
          setRedeemAmount(0);
          setMinRedeemPoints(data.minimum_points);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleConfirm = async () => {
    setLoader(true);
    try {
      if (redeemPoints < minRedeemPoints) {
        showSnackbarWithMessage({
          type: "error",
          message: `Minimum redemption is ${formatNumberWithCommas(
            minRedeemPoints
          )} points (~$${formatNumberWithCommas(minRedeemPoints / CONVERSION_POINTS)}).`,
        });
        return;
      }
      if (selectedValue) {
        const {
          data: { success, message },
        } = await generateGiftCard(selectedValue);
        if (success) {
          await getRedeemPointsData();
          showSnackbarWithMessage({
            type: "success",
            message,
          });
          trackCustomEvent(AnalyticsEvents.REWARD_REDEEMED, {
            redeemed_amount: redeemAmount,
          });
          handleRedeemClose();
          navigate("/my-points");
        } else {
          showSnackbarWithMessage({
            type: "error",
            message,
          });
        }
      }
    } catch (e) {
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    } finally {
      setLoader(false);
    }
  };

  const verifyTokenFunc = async () => {
    try {
      const location = useLocation();
      const searchParams = new URLSearchParams(location.search);
      const tokens = searchParams.get("landing_page_tokens");
      const gtmCode = searchParams.get("s");
      if (gtmCode) {
        setGtmCode(gtmCode); // Save GTM code to local storage
      }
      if (!tokens) return;
      saveAuthData(JSON.parse(decodeURIComponent(tokens)));
      const auth = JSON.parse(decodeURIComponent(tokens));
      const {
        data: { success, data },
      } = await verifyTokenApi({ accessToken: auth.accessToken });
      if (success) {
        setUserEmail(data.verifiedData.email);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    if (true) {
      getRedeemPointsData();
      verifyTokenFunc();
    }
    // Initialize GTM here after data is fetched
    const gtmCode = getGtmCode();
    const isGtmEnabled = config[process.env?.REACT_APP_ENV?.toUpperCase()]?.GTM_ENABLED;
    if (isGtmEnabled && gtmCode && !gtmInitialized) {
      TagManager.initialize({ gtmId: `GTM-${gtmCode}` });
      setGtmInitialized(true);
    }
  }, []);

  return (
    <>
      <DashboardNavbar />
      <NavbarAlert />
      <DashboardLayout>
        {config[process.env?.REACT_APP_ENV?.toUpperCase()]?.GTM_ENABLED && getGtmCode() && (
          <div
            dangerouslySetInnerHTML={{
              __html: `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-${getGtmCode()}"
                height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`,
            }}
          />
        )}
        {dashboardLoader && <SimpleBackdrop />}
        <MDBox
          py={2}
          sx={{
            mt: 9,
            "@media (max-width:992px)": {
              mt: 8,
            },
          }}
        >
          {campaignEnrollments.length > 0 && (
            <CampaignBannerCarousel
              enrollments={campaignEnrollments}
              onExpireRefresh={campaignData}
            />
          )}

          <PendingWelcomeBonusBanner items={pendingWelcomeBonuses} />

          <div className="flex items-stretch justify-between gap-3 md:gap-4 flex-col md:flex-row">
            <MDBox mb={1.5} sx={{ width: "100%" }}>
              <StatCardWithButton
                header="Available To Redeem"
                onClick={() => {
                  setopenRedeemModal(true);
                }}
                icon={true}
                btnText="Redeem Now"
                bottomText={
                  !!isPendingRedeemptionRequestAmount &&
                  formatNumberWithCommas(isPendingRedeemptionRequestAmount / 100, { asCurrency: true })
                }
                subText={
                  <h2 className="text-2xl font-semibold text-gray-900">
                    {availablePoints
                      ? formatNumberWithCommas(availablePoints) + " points"
                      : 0 + " points"}{" "}
                    <span className="text-[#475467]">
                      {" "}
                      {availablePoints
                        ? " ($" + formatNumberWithCommas(availablePoints / CONVERSION_POINTS, { asCurrency: true }) + ")"
                        : " ($0.00)"}
                    </span>
                  </h2>
                }
                disabled={
                  redeemPoints < minRedeemPoints ||
                  availablePoints - isPendingRedeemptionRequestAmount <= 0 ||
                  !!isPendingRedeemptionRequestAmount
                }
                disabledReason={getRedeemDisabledReason({
                  points: redeemPoints,
                  minPoints: minRedeemPoints,
                  pendingAmountCents: isPendingRedeemptionRequestAmount || 0,
                  conversion: CONVERSION_POINTS,
                })}
              />
            </MDBox>
            <MDBox mb={1.5} sx={{ width: "100%" }}>
              <StatCard
                pointsEarned={
                  totalPointsEarned
                    ? formatNumberWithCommas(totalPointsEarned) + " points"
                    : 0 + " points"
                }
                dollarAmountEarned={
                  totalPointsEarned
                    ? " ($" + formatNumberWithCommas(totalPointsEarned / CONVERSION_POINTS, { asCurrency: true }) + ")"
                    : " ($0.00)"
                }
                pointsRedeemed={
                  formatNumberWithCommas(totalRedeemedPoints ? Math.abs(totalRedeemedPoints) : 0) + " points"
                }
                dollarAmountRedeemed={
                  totalRedeemedPoints
                    ? " (~$" +
                      formatNumberWithCommas(
                        Math.abs(totalRedeemedPoints) / CONVERSION_POINTS, { asCurrency: true }
                      ) +
                      ")"
                    : " (~$0.00)"
                }
                pointsExpiring={
                  expirePoints?.data?.pointsExpiringInNext30Days
                    ? formatNumberWithCommas(expirePoints.data.pointsExpiringInNext30Days) +
                      " points"
                    : "0 points"
                }
                dollarAmountExpiring={
                  expirePoints?.data?.pointsExpiringInNext30Days
                    ? " (~$" +
                      formatNumberWithCommas(
                        expirePoints.data.pointsExpiringInNext30Days / CONVERSION_POINTS, { asCurrency: true }
                      ) +
                      ")"
                    : " (~$0.00)"
                }
              />
            </MDBox>
            <MDBox mb={1.5} sx={{ width: "100%" }}>
              <StatCardWithButton />
            </MDBox>
          </div>

          <MDBox mt={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={8}>
                <Projects topRestaurantData={topRestaurantData} brandData={brandData} />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                {!miniSidenav && <OrdersOverview recentOrderData={recentOrderData} />}
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        <UpdateNameModal
          open={openUpdateNameModal}
          onConfirm={updateCustomerName}
          loader={nameModalLoader}
          handleClose={handleNameModalClose}
          initialFirstName={verifiedCustomer?.firstName || ""}
          initialLastName={verifiedCustomer?.lastName || ""}
          removeOnClose={true}
        />
        <UpdatePasswordModal
          open={openUpdatePasswordModal}
          onConfirm={updatePassWord}
          loader={modalLoader}
          userEmail={verifiedCustomer?.email}
          userPassword={userPassword}
          handleClose={handleClose}
          setLoader={setModalLoader}
          title="Set Password"
          setUserPassword={setUserPassword}
          spinner={spinner}
          removeOnClose={true}
          forgotPassword={verifiedCustomer?.forgotPassword}
        />
        <EmailCustomModal
          open={openRedeemModal}
          handleClose={handleRedeemClose}
          color={"success"}
          title={`You are about to redeem ${
            formatNumberWithCommas(redeemPoints - (isPendingRedeemptionRequestAmount || 0))
          } points equivalent to $${
            formatNumberWithCommas(redeemAmount -
            (isPendingRedeemptionRequestAmount ? isPendingRedeemptionRequestAmount / 100 : 0), { asCurrency: true })
          } `}
          subtitle={
            "We will send you an Amazon.com gift card of the same value within the next 24-48 hours to the selected email address."
          }
          subtitle2={
            <>
              We recommend to use your <strong>personal email</strong>. If you use a work email,
              your organization policies may block it for spam or it may be quarantined.
              Additionally, the email&apos;s contents may be visible to your system admin which
              could compromise your claim code.
            </>
          }
          userEmail={userEmail}
          description={
            status.isOTPVisible ? (
              <p>
                Please check your inbox and spam for emails from:
                <p>{notificationEmail}</p>
              </p>
            ) : (
              ""
            )
          }
          onConfirm={handleConfirm}
          loader={loader}
          isIcon={true}
          setSelectedValue={setSelectedValue}
          selectedValue={selectedValue}
          setStatus={setStatus}
          status={status}
          setOtp={setOtp}
          otp={otp}
        />
        {showOtpModal && (
          <OtpConfirmationModal
            identifier={verificationIdentifier}
            type={verificationType}
            open={showOtpModal}
            onClose={handleDismissOtpModal}
            onVerify={handleOtpVerify}
            onSendOTP={handleSendOTP}
          />
        )}
      </DashboardLayout>
    </>
  );
}

export default Dashboard;
